import { Box, Card, Text } from '@factorialco/deprecated-design-system'
import {
  PerformanceScoreConfigurationWithPoliciesFragment,
  PerformanceTargetFinalScoreCardFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { StrategyScores } from './StrategyScores'

type Props = {
  scoreConfiguration: PerformanceScoreConfigurationWithPoliciesFragment
  targetWithScores: PerformanceTargetFinalScoreCardFragment
}

export const TargetFinalScoreCard = ({ scoreConfiguration, targetWithScores }: Props) => {
  const finalScore = targetWithScores?.reviewFinalEmployeeScore
  const strategyScores = targetWithScores?.reviewStrategyEmployeeScores

  const canSeeScoreDetails = Boolean(targetWithScores?._policies?.seeTargetScoreDetails?.can)
  const canSeeWeights = Boolean(scoreConfiguration?._policies?.seeWeights?.can)
  const canSeeFinalScore = Boolean(targetWithScores?._policies?.seeTargetFinalScore?.can)

  if (!canSeeFinalScore) {
    return null
  }

  const getTooltipText = () => {
    if (finalScore?.score) {
      return i18n.t('performance_process.targets.insights.performance_score_tooltip.calculated')
    }

    return canSeeScoreDetails
      ? i18n.t('performance_process.targets.insights.performance_score_tooltip.missing_reviews')
      : i18n.t('performance_process.targets.insights.performance_score_tooltip.unavailable')
  }

  return (
    <Box width="full" gridColSpan={{ xxs: 5, m: 4, l: 3 }}>
      <Card key={i18n.t('performance_process.targets.insights.performance_score')}>
        <Card.Title size="small" tooltip={getTooltipText()}>
          {i18n.t('performance_process.targets.insights.performance_score')}
        </Card.Title>
        <Card.Content>
          <Box flexDirection="column" gap="s16" width="full">
            <Box flexDirection="row" alignItems="baseline">
              <Text size="700" weight="medium" color="grey1000">
                {finalScore?.score ? i18n.formatNumber(finalScore.score) : '-'}
              </Text>
              {finalScore?.scaleMax && (
                <Text size="500" weight="medium" color="grey1000">
                  /{i18n.formatNumber(finalScore.scaleMax)}
                </Text>
              )}
            </Box>

            {canSeeScoreDetails && strategyScores && (
              <StrategyScores
                strategyScores={strategyScores}
                scoreConfiguration={scoreConfiguration}
                canSeeWeights={canSeeWeights}
              />
            )}
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )
}
